import styled from 'styled-components';

export const Container = styled.form`
  display: grid;
  grid-template-columns: 25rem 1fr;
  grid-template-rows: 1fr 2.5rem;
  grid-gap: 0.5rem;
  padding: 1rem;
`;
